// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"d507d328","145":"567d5cab","161":"1abde2cd","425":"b9f0d934","477":"36335461","640":"c30abb92","671":"188d17d5"}[chunkId] + ".css";
};